module.exports = __webpack_public_path__ + "media/img/Landing_Page/ig-icon-ad5e2813779210c9396e461e8f3c694c.png";